import React, { useContext } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { storeContext } from '../Store/storeContext';
export const UpdateModal = ({ email, courses }) => {
  const [state, dispatch] = useContext(storeContext);
  const handleClose = () => {
    dispatch({ type: 'UPDATE_MODAL' });
  };

  return (
    <>
      <Modal
        backdrop='static'
        keyboard={false}
        show={state.isUpdateModal}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Student Account Updated</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='text-center'>
            Woohoo, you have successfully updated a user
          </p>

          <Form className='p-2'>
            <Form.Label>Student Email</Form.Label>
            <Form.Control value={email} readOnly type='text' />
            <br></br>
            <Form.Label>Registered Courses</Form.Label>
            <Row>
              {courses.map((elem) => {
                return (
                  <Col key={elem} md={6} className='my-2'>
                    <Form.Control value={elem} readOnly type='text' />
                  </Col>
                );
              })}
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
